/**
 * Sticky add-to-cart bar for product pages.
 *
 * Fixes applied 2026-07-31:
 *  - The bar's ADD TO CART did nothing. `form[action$="/cart/add"]` matches the
 *    Shop Pay *installment* form first, which has no `.product-form__submit`,
 *    so the click handler resolved to null and silently no-oped. Now we pick the
 *    real add-to-cart form explicitly.
 *  - The show/hide threshold was measured once at DOMContentLoaded, before
 *    images had laid out, so the bar appeared at the wrong scroll position.
 *    It is now recomputed on load and resize.
 *  - The floating WhatsApp button overlapped the bar's wishlist button. The bar
 *    now toggles `mz-sticky-open` on <body> so CSS can lift it clear.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // The real product form — NOT the installment form that precedes it in the DOM.
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action$="/cart/add"]'));
    var form =
      document.querySelector('form[action$="/cart/add"][data-type="add-to-cart-form"]') ||
      forms.filter(function (f) { return f.querySelector('.product-form__submit'); })[0];
    if (!form) return;

    var submit = form.querySelector('.product-form__submit');
    if (!submit) return;

    var title = document.querySelector('.product__title');
    var priceEl = document.querySelector('.mz-price__sale');
    var img = document.querySelector('.product__media-gallery img,.product__media img');
    var mobile = window.innerWidth <= 749;
    if (!title || !priceEl) return;

    var bar = document.createElement('div');
    bar.className = 'mz-sticky';
    if (!mobile) {
      bar.innerHTML =
        (img ? '<img class="mz-sticky__img" src="' + img.src + '" alt="">' : '') +
        '<div class="mz-sticky__info"><p class="mz-sticky__name">' +
        (title.textContent || '').trim().slice(0, 50) +
        '</p><p class="mz-sticky__price">' + (priceEl.textContent || '') + '</p></div>';
    }
    bar.innerHTML +=
      '<button type="button" class="mz-sticky__btn"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>ADD TO CART</button>' +
      '<button type="button" class="mz-sticky__wish" aria-label="Wishlist"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg></button>';
    document.body.appendChild(bar);

    // Click the real submit so <product-form> handles it and opens the cart drawer.
    bar.querySelector('.mz-sticky__btn').addEventListener('click', function () {
      submit.click();
    });

    var mainWish = document.querySelector('.mz-wish');
    var stickyWish = bar.querySelector('.mz-sticky__wish');
    stickyWish.addEventListener('click', function () {
      stickyWish.classList.toggle('wished');
      if (mainWish) {
        mainWish.classList.toggle('wished');
        var svg = mainWish.querySelector('path');
        if (svg) svg.setAttribute('fill', mainWish.classList.contains('wished') ? '#a3188c' : 'none');
      }
    });

    // Measure after layout settles, and again whenever it can change.
    var threshold = 0;
    function measure() {
      var trigger = document.querySelector('.mz-inline-action-row') || form;
      threshold = trigger.getBoundingClientRect().bottom + window.scrollY + 60;
      update();
    }
    function update() {
      var show = window.scrollY > threshold;
      bar.classList.toggle('show', show);
      document.body.classList.toggle('mz-sticky-open', show);
    }

    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('scroll', update, { passive: true });
  });
})();
